module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "container",
    attrs: {
      "id": "blogHome"
    }
  }, [_vm._m(0), " ", _vm._h('div', {
    staticClass: "blog"
  }, [_vm._h('div', {
    staticClass: "row"
  }, [_vm._l((_vm.posts), function(post) {
    return _vm._h('div', {
      staticClass: "col-md-8 offset-md-2 post"
    }, [_vm._h('div', [_vm._h('h3', [_vm._s(post.titulo)]), " ", _vm._h('p', [_vm._s(post.descripcionCorta)]), " ", _vm._h('div', {
      staticClass: "clearfix"
    }, [_vm._h('router-link', {
      staticClass: "btn btn-sm btn-default float-xs-right",
      attrs: {
        "to": {
          name: 'postItem',
          params: {
            id: post.key
          }
        }
      }
    }, ["\n                    LEER MAS +\n                "])])]), " ", _vm._h('hr')])
  })]), " ", _vm._h('div', {
    staticClass: "row"
  }, [_vm._h('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [(_vm.nuevos) ? _vm._h('button', {
    staticClass: "btn btn-info btn-block",
    on: {
      "click": _vm.nextPosts
    }
  }, ["MAS NOTICIAS"]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "header"
  }, [_vm._h('h2', ["NOVEDADES"]), " ", _vm._h('div', {
    staticClass: "row"
  }, [_vm._h('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_vm._h('p', ["Ingrese a nuestro blog y enterese de las ultimas noticias del mundo automotor"])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6049812d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog-Home.vue
// module id = 68
// module chunks = 1